import { useState } from "react";
import useLabels from "../../hooks/useLabels";
import { useBackendHealth } from "../../hooks/useBackendHealth";
import { catchUp } from "../../services/syncManager";
import CacheManager from "../../services/cacheManager";
import { useDispatch, useSelector } from "react-redux";
import { selectActiveWinery } from "../../context/selectors";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import "./styles/index.scss";

const RECOVERED_BANNER_DURATION_MS = 3000;

const BackendStatusBanner = () => {
  const [getLabel] = useLabels();
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate();
  const wineryId = useSelector(selectActiveWinery)?.id;
  const [showRecovered, setShowRecovered] = useState(false);

  const { isBackendUp } = useBackendHealth({
    onRecovered: () => {
      if (wineryId) {
        catchUp({
          dispatch,
          axios: axiosPrivate,
          wineryId,
          cacheManager: new CacheManager(dispatch, axiosPrivate),
        });
      }
      setShowRecovered(true);
      setTimeout(() => setShowRecovered(false), RECOVERED_BANNER_DURATION_MS);
    },
  });

  if (!isBackendUp) {
    return (
      <div className="backend_status_banner down">
        <p>{getLabel("backend_status_down")}</p>
      </div>
    );
  }

  if (showRecovered) {
    return (
      <div className="backend_status_banner recovered">
        <p>{getLabel("backend_status_recovered")}</p>
      </div>
    );
  }

  return null;
};

export default BackendStatusBanner;
